var React = require('react');

function ArrowBoldInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M30 14.6323L24.998 19.6753L24.997 19.6743L16.1128 28.6313L11.1108 23.5884L16.458 18.1974L9.95185e-07 18.1974L3.71674e-07 11.0653L16.458 11.0653L11.1108 5.6743L16.1128 0.631347L24.997 9.58839L24.998 9.5874L30 14.6304L29.999 14.6313L30 14.6323Z","fill":"#FCFAFA"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"30","height":"28","fill":"white","transform":"translate(30 28.6313) rotate(180)"})))]);
}

ArrowBoldInline.defaultProps = {"width":"30","height":"29","viewBox":"0 0 30 29","fill":"none"};

module.exports = ArrowBoldInline;

ArrowBoldInline.default = ArrowBoldInline;
